function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25z",
  fill: "#454545"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.89 19.77h-3.86c.17-1.49.62-2.84 1.34-4.09 1.79-3.1 4.38-5.23 7.86-6.18 5.58-1.53 11.44.98 14.21 6.06.23.41.44.83.63 1.26.17.37.02.62-.39.62-.98.01-1.98.07-2.95-.03-.38-.04-.8-.41-1.04-.74-1.76-2.41-4.09-3.75-7.09-3.78-3.89-.05-7.37 2.51-8.52 6.24-.06.19-.12.41-.19.64zM10 23.39c1.26 0 2.44-.02 3.63.03.15.01.35.34.41.56.6 2.17 1.93 3.8 3.81 4.95 3.6 2.21 8.43 1.34 11.19-1.95.2-.24.39-.48.56-.73.33-.47.77-.7 1.36-.68.8.03 1.6 0 2.4.01.67.01.81.22.54.84-2.15 4.92-7.32 7.91-12.79 7.47-5.94-.48-10.28-5.09-11.06-10.07-.03-.11-.03-.21-.05-.43zM36.46 40.1c-.8 0-1.6.01-2.4 0-.63-.01-.85-.37-.54-.93.8-1.43 1.61-2.86 2.43-4.28.29-.49.7-.5.99-.01.85 1.45 1.68 2.91 2.49 4.38.25.46.03.81-.5.83-.83.03-1.65.01-2.47.01z",
  fill: "#16A7E7"
});

var SvgSourceGarmin = function SvgSourceGarmin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceGarmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_garmin.97494e93.svg";
export { ForwardRef as ReactComponent };